import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import MainLayout from "../components/MainLayout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputText} from "primereact/inputtext";
import {toast} from "react-toastify";
import {Eye} from "lucide-react";
import {Calendar} from "primereact/calendar";
import moment from "moment";
import "moment/locale/uz";
import {getReceivingInvoiceByDate} from "../services/invoice.service";

const InvoicesHistoryPage = () => {
	const [invoices, setInvoices] = useState([]);
	const [searchText, setSearchText] = useState("");
	const [loading, setLoading] = useState(false);
	const [date, setDate] = useState(new Date());
	const navigate = useNavigate();
	const inputRef = useRef(null);

	const filteredData = invoices.filter((item) =>
		item.id.toString().includes(searchText.toLowerCase())
	);

	useEffect(() => {
		const fetchInvoices = async () => {
			setLoading(true);
			try {
				const invoices = await getReceivingInvoiceByDate(date);
				setInvoices(invoices.invoices);
			} catch (error) {
				console.error("Error fetching invoices", error);
				toast.error("Накладной юклашда хатолик");
			} finally {
				setLoading(false);
			}
		};

		fetchInvoices();
	}, [date]);

	return (
		<MainLayout header="Кабул килинган накладнойлар">
			<div>
				<div className="flex items-end gap-4 mb-4">
					<div className="relative flex items-center w-full">
						<i className="absolute text-gray-400 -translate-y-1/2 pointer-events-none pi pi-search left-3 top-1/2" />
						<InputText
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
							className="w-full h-10 pt-1 border pl-9"
							placeholder="Накладной рақами..."
						/>
					</div>
					<div className="flex flex-col">
						<label className="mb-1 text-sm font-medium text-gray-700">
							Накладной ойи
						</label>
						<Calendar
							value={date}
							onChange={(e) => setDate(e.value)}
							className="px-4 py-2 border"
							view="month"
							dateFormat="MM yy"
							inputRef={inputRef}
							onSelect={() => {
								setTimeout(() => inputRef.current?.blur(), 125);
							}}
						/>
					</div>
				</div>
				<DataTable
					className="custom-row-border"
					value={filteredData}
					emptyMessage="Накладнойлар йўқ"
					paginator
					rows={10}
					rowsPerPageOptions={[10, 25, 50]}
					loading={loading}>
					<Column field="id" header="Накладной рақами" />
					<Column
						field="date"
						header="Накладной санаси"
						body={(rowData) => moment(rowData.date).format("D MMMM YYYY")}
					/>
					<Column
						field="demands"
						header="Заказлар"
						body={(rowData) =>
							Array.isArray(rowData.demands)
								? rowData.demands.join(", ")
								: rowData.demands
						}
					/>
					<Column
						field=""
						header="Амал"
						body={(rowData) => (
							<Eye
								className="cursor-pointer"
								onClick={() =>
									navigate("/invoice-creation", {
										state: {invoice: rowData, history: true},
									})
								}
							/>
						)}
					/>
				</DataTable>
			</div>
		</MainLayout>
	);
};

export default InvoicesHistoryPage;
